export const JSON_ONE42 = {
   
    "ag_id": "paygate",
    "me_id": "202104210302",
    "request_type": "Fetch List of VA",
    "channel": "WEB",
    "From": "29-09-2021",
    "To": "27-10-2021"
    }



